import React , { useEffect, useState } from 'react';
import Layout from "../../../components/mobile/Layout/layoutmobile";

import './css/termsofuse.css';
const Tracuuthongtin=()=> {
    const Handleclick =()=>{
        window.history.back();
    }
  return (
   <Layout>
        <div className="container">
        <div className="header row d-flex mgx-0 mgt-10">
            <div className="col-1 in-f" onClick={Handleclick}>
                <i className="fa-solid fa fa-chevron-left"></i>
            </div>
            <div className="col-10 flex-center">
                <span className="text_14 font_700">Phương thức thanh toán</span>
            </div>
            <div className="col-1"></div>
        </div>
        {/* <h1 className='d-none'>CÁC PHƯƠNG THỨC THANH TOÁN KHI MUA SẮM TẠI BIBO MART</h1> */}
        <div className='container page-builder-ltr m-0 p-0'>
            <div className='container-page-footer m-0 p-0'>
            <div style={{height:10}}></div>
               <div className='title-payment text-center'>
                   <strong>PHƯƠNG THỨC THANH TOÁN</strong> 
                </div> 
                <div><strong>
                1.	Mua hàng tại Cửa hàng
                </strong></div>
                <div style={{paddingLeft:15}}>
                Quý khách có thể lựa chọn thanh toán tại Cửa hàng theo các phương thức:
                <div style={{paddingLeft:15,paddingBottom:10}}>
                -	Thanh toán bằng tiền mặt<br/>
                -	Thanh toán bằng thẻ ATM, thẻ tín dụng<br/>
                -	Thanh toán chuyển khoản qua Internet Banking<br/>
                -	Thanh toán qua VNPAY-QR<br/>
                -	Thanh toán qua Momo<br/>
                -	Thanh toán qua ZaloPay
                </div>
                </div>
                <div><strong>
                2.	Mua hàng trực tuyến
                </strong></div>
                <div style={{paddingLeft:15}}>
                    Khi mua hàng trực tuyến tại ứng dụng Bibo Mart hoặc website bibomart.com.vn, Quý khách có thể lựa chọn một trong hai phương thức thanh toán sau:
                    <div>
                        <strong>
                        2.1. Thanh toán khi nhận hàng (COD)
                        </strong>
                    </div>
                    <div style={{paddingLeft:15}}>
                    -	Tại bước đặt hàng trên App hoặc Website, Quý khách chọn phương thức <strong>Thanh toán khi nhận hàng.</strong> <br/>
                    -	Khi đơn hàng được giao đến địa chỉ của Quý khách, Quý khách thanh toán trực tiếp bằng tiền mặt hoặc các hình thức khác (nếu được hỗ trợ) cho nhân viên giao hàng.<br/>
                    </div>
                     <div><strong>
                         2.2. Thanh toán trực tuyến qua cổng thanh toán OnePay
                            </strong></div>  
                            <div style={{paddingLeft:15,paddingBottom:10}}>
                            OnePay là cổng thanh toán trực tuyến an toàn và hiện đại mang đến cho Quý khách nhiều lựa chọn thanh toán linh hoạt, gồm các phương thức thanh toán:<br/>
                            -	Thẻ tín dụng/Ghi nợ quốc tế (Visa, Mastercard, JCB)<br/>
                            -	Thanh toán qua Apple Pay, Google Pay<br/>
                            -	Thẻ ATM nội địa/Tài khoản ngân hàng nội địa<br/>
                            -	Ứng dụng di động ngân hàng hoặc ví điện tử
                            </div>
                </div>
                {/* <div className='text-center'>
                    <img src="/static/image/method-payment.png" alt="payment" />
                </div> */}
                <div style={{paddingLeft:15}}>
                        Để thanh toán qua OnePay, Quý khách thực hiện theo các thao tác sau:<br/>
                1.	Sau khi chọn sản phẩm, tiến hành đặt hàng và chọn phương thức thanh toán là Thanh toán OnePay.<br/>
                2.	Hệ thống sẽ chuyển đến trang thanh toán bảo mật của OnePay.<br/>
                3.	Chọn một phương thức thanh toán.<br/>
                4.	Nhập đúng thông tin thẻ của Quý khách (số thẻ, ngày hết hạn, mã CVV) nếu dùng thẻ Visa hoặc thông tin tài khoản ngân hàng nội địa nếu dùng thẻ ATM
                 … (Theo phương thức thanh toán Quý Khách đã lựa chọn).<br/>
                5.	Kiểm tra thông tin và nhấn Thanh toán.<br/>
                6.	Nhập mã OTP để hoàn tất giao dịch (Nếu cần theo phương thức thanh toán Quý khách đã lựa chọn).<br/>
                7.	Sau khi thanh toán thành công, hệ thống sẽ chuyển về App/Web của Bibo Mart với đơn hàng đã được thanh toán trực tuyến thành công.<br/>
                <div>
                    <div>
                    <strong>
                2.3. Thời gian hoàn tiền cho đơn hàng thanh toán OnePay
                    </strong>
                        </div>
                        <div style={{paddingLeft:15}}>
                        Trong trường hợp đơn hàng thanh toán OnePay không thể giao đến Quý Khách thì thời gian hoàn tiền theo phương thức thanh toán đã được lựa chọn:<br/>
                        -	Thẻ VISA, MasterCard, JCB: 7 - 10 ngày làm việc<br/>
                        -	Thẻ ATM nội địa: 3 - 5 ngày làm việc<br/>
                        -	QR Code: 10 - 13 ngày làm việc      
                        </div>
                                  
                    </div>
                
                </div>
                </div>
                <div style={{height:10}}></div>
        </div>  

        <div className="footer text_13 font_500">
            <div className="row">
                <div className="col-12">
                    <div className="card card-border flex-center-col">
                        <span className="">Mọi thắc mắc, vui lòng liên hệ:</span>
                        <span className="font_700 color_red">P. Chăm sóc Khách hàng</span>
                        <span className="font_700 color_red">Công ty Cổ phần Bibo Mart TM</span>
                        <span className="">Hotline: 1800 6886 (Miễn phí)</span>
                        <span className="">Email: cskh@bibomart.com.vn</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
   </Layout>
  )
}
export default Tracuuthongtin;